<template>
  <div v-loading="loadingContent">
      <ed-form :data="formData" :response="response" :config="config" :itens="formDataItems">
							<div slot="form-footer" >
								<div class="col-md-12 btn-login">
									<ed-button 	
										icon="fa fa-floppy-o"
										type="success"
										:click="salvar"
										:loading="loadingSave"
										value="Salvar"
									/>
								</div>
							</div>
				</ed-form>
  </div>
</template>

<script>

import Rest from "common/rest";
import EdForm from 'common/form'
import EdButton from 'common/button'
import ItemsFormEditar from './_form/meu-cadastro'

export default {
  components: {EdForm,EdButton},
  mixins: [Rest],
  watch:{
    'formData.id_fdt'(){
      this.getFuncao();
    },
    'formData.id_funcao'(){
      this.getGHE();
    }
  },
  data() {
    return {
      loadingContent:false,
      loadingSave:false,
      response:{},
      formDataItems:[],
      config:{
        estado:true,
        tipo:[],
        readonly:{
          nome:true,
          cnpj:true,
          u_cpf:true,
          u_nome:true,
        }
      },
      formData:{
          id: null,
          id_estado: null,
          id_cidade: null,
          nome: null,
          cnpj: null,
          email: null,
          tel_com: null,
          r_nome: null,
          r_email: null,
          r_tel_com: null,
          u_nome:null,
          u_cpf:null,
          u_email:null,
          cep:null,
          end:null,
          num:null,
          bairro:null,
          comp:null,
          log:[],
          obs:null,
          created_at: null,
          updated_at: null,
      },
    };
  },

  created() {
  },

  mounted(){
  this.getEmpresa();
  this.formDataItems = ItemsFormEditar;
  },

  methods: {

    getEmpresa() {

      this.loadingContent = true;
      this.response = {};

      this.get("meu-cadastro").then(result => {

        result = result[0];

        console.log(result)
        
        this.loadingContent = false;
        this.response = result;

        if(result.status == 200) {
          var data = result.data;

          this.formData = {
            id: data.id,
            id_estado: data.id_estado,
            id_cidade: data.id_cidade,
            nome: data.nome,
            cnpj: data.cnpj,
            email: data.email,
            tel_com: data.tel_com,
            r_nome: data.r_nome,
            r_email: data.r_email,
            r_tel_com: data.r_tel_com,
            cep:data.cep,
            end:data.end,
            num:data.num,
            bairro:data.bairro,
            comp:data.comp,
            obs: data.obs,
            created_at: data.created_at,
            updated_at: data.updated_at,

            senha_atual:null,
            senha_nova:null,
            senha_confirma:null,

            u_nome:this.usuario.logged.nome,
            u_cpf:this.usuario.logged.usuario,
            u_email:this.usuario.logged.email,
          };
        } 
      
      });
    },

    salvar(){

      this.loadingSave = true;
      this.response = {};
      
      this.post('meu-cadastro',this.formData).then((result) =>{
        result = result[0];

        this.loadingSave = false;

        this.response = result;

        if(result.status == 200){
          this.edMsg('Dados atualizados com sucesso');
          this.getEmpresa();
        }
      });

    }
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?71f086c4